import React, { FC } from 'react'

interface Props {
  size?: number
}

export const YouTubeIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="16" fill="white" />
    <path
      d="M14.3809 18.5951V12.9285L19.238 15.7715L14.3809 18.5951ZM25.5199 11.8494C25.5199 11.8494 25.3297 10.5015 24.7476 9.90734C24.0085 9.12776 23.1804 9.12453 22.8007 9.07919C20.0824 8.88086 16.004 8.88086 16.004 8.88086H15.9959C15.9959 8.88086 11.9175 8.88086 9.19912 9.07919C8.81864 9.12453 7.99131 9.12776 7.25141 9.90734C6.66936 10.5015 6.47993 11.8502 6.47993 11.8502C6.47993 11.8502 6.28564 13.432 6.28564 15.0146V16.5001C6.28564 18.0835 6.47993 19.667 6.47993 19.667C6.47993 19.667 6.66936 21.0148 7.25141 21.609C7.99131 22.3886 8.96193 22.3635 9.39422 22.4452C10.9485 22.5966 15.9999 22.6428 15.9999 22.6428C15.9999 22.6428 20.0824 22.6363 22.8007 22.4388C23.1812 22.3926 24.0085 22.3894 24.7476 21.6098C25.3305 21.0156 25.5199 19.667 25.5199 19.667C25.5199 19.667 25.7142 18.0843 25.7142 16.5009V15.0162C25.7142 13.4328 25.5199 11.8494 25.5199 11.8494Z"
      fill="#FF0000"
    />
  </svg>
)
